export enum SurveySource {
  COLLEAGUE_TEACHER = "Colleague / Another Teacher",
  ONLINE_SEARCH = "Online Search (Google, etc.)",
  FACEBOOK = "Facebook",
  INSTAGRAM = "Instagram",
  TIKTOK = "TikTok",
  CLASSBANK_WEBINAR = "Webinar",
  CONFERENCE = "Conference",
  BLOG_POST = "Blog Post / Article",
  EMAIL_FROM_CLASSBANK = "Email from ClassBank",
  A_STUDENT = "A student",
  OTHER = "Other",
}

export const SURVEY_REQUIRES_DETAILS = [
  SurveySource.COLLEAGUE_TEACHER,
  SurveySource.ONLINE_SEARCH,
  SurveySource.CONFERENCE,
  SurveySource.OTHER,
] as SurveySource[]

export const requiresSurveyDetails = (survey: string) => {
  return SURVEY_REQUIRES_DETAILS.includes(survey as SurveySource)
}

export const getSurveyOptions = () => Object.values(SurveySource)
